<template>
  <div class="container">
    <div class="spaced-row">
      <h3>Locations</h3>
      <div class="grow"></div>
      <mad-button color="brown" @click.prevent="goToCreate">
        <mad-icon mdi="plus" />Create location
      </mad-button>
    </div>

    <br>

    <mad-datatable :rows="rows" :columns="columns" :per-page="10">
      <template slot="locations" slot-scope="{row}">
        {{ row.locations }}
      </template>
      <template slot="client vouchers" slot-scope="{row}">
        {{ row.amount_of_vouchers }}
      </template>
    </mad-datatable>
  </div>
</template>

<script>
export default {
  data: () => ({
    coupons: [],
    columns: [
      { key: 'name', sort: 'name' },
      { key: 'client vouchers', sort: v => v.vouchers },
    ],
  }),

  computed: {
    rows() {
      return this.locations
        .map(location => ({
          ...location,
          click: e => this.goToLocation(location),
        }))
    },

    locations() {
      return this.$store.state.locations || []
    },
  },

  watch: {
    data: {
      handler() {
        this.fetchData()
      },
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      if (!this.locations) return

      await this.$store.dispatch('refreshLocations', {})
    },
    goToLocation(location) {
      this.$router.push(`/locations/${location.id}`)
    },
    goToCreate() {
      this.$router.push('/locations/new-location')
    },
  },
}
</script>

<style>
</style>
